export default function Divider(theme) {
  return {
    MuiDivider: {
      styleOverrides: {
        root: {
          display: "inline-block",
          borderColor: `${theme.palette.grey.g4} !important`,
          backgroundColor: `${theme.palette.grey.g4} !important`,
        },
      },
    },
  };
}
